<template>
  <v-row class="d-flex flex-column flex-md-row">
    <v-col class="flex-sm-wrap flex-sm-column" cols="12" md="6">
      <v-row>
        <v-col cols="12">
          <a :href="largeLeft.href">
            <BaseImage 
              :mobileSrc="largeLeft.mobileSrc" 
              :desktopSrc="largeLeft.desktopSrc" 
            />
          </a>
        </v-col>
      </v-row>
      <v-row class="flex-sm-wrap">
        <v-col cols="12" sm="6">
          <a :href="smallLeft1.href">
            <BaseImage 
              :mobileSrc="smallLeft1.mobileSrc" 
              :desktopSrc="smallLeft1.desktopSrc"
            />
          </a>
        </v-col>
        <v-col cols="12" sm="6">
          <a :href="smallLeft2.href">
            <BaseImage 
              :mobileSrc="smallLeft2.mobileSrc" 
              :desktopSrc="smallLeft2.desktopSrc" 
            />
          </a>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="flex-sm-wrap flex-sm-column" cols="12" md="6">
      <v-row>
        <v-col cols="12" sm="6">
          <a :href="smallRight1.href">
            <BaseImage 
              :mobileSrc="smallRight1.mobileSrc" 
              :desktopSrc="smallRight1.desktopSrc" 
            />
          </a>
        </v-col>
        <v-col cols="12" sm="6">
          <a :href="smallRight2.href">
            <BaseImage 
              :mobileSrc="smallRight2.mobileSrc" 
              :desktopSrc="smallRight2.desktopSrc" 
            />
          </a>
        </v-col>
      </v-row>
      <v-row class="flex-sm-wrap">
        <v-col cols="12">
          <a :href="largeRight.href">
            <BaseImage 
              :mobileSrc="largeRight.mobileSrc" 
              :desktopSrc="largeRight.desktopSrc" 
            />
          </a>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import BaseImage from "../../baseImage/components/BaseImage";
export default {
  name: "ImageGrid",
  components: {BaseImage},
  props: {
      largeLeft: {
          type: Object,
          required: true,
      },
      smallLeft1: {
          type: Object,
          required: true,
      },
      smallLeft2: {
          type: Object,
          required: true,
      },
      largeRight: {
          type: Object,
          required: true,
      },
      smallRight1: {
          type: Object,
          required: true,
      },
      smallRight2: {
          type: Object,
          required: true,
      }
  },
};
</script>
